<template>
  <div class="annotations-manager">
    <div class="annotations-manager__header">
      <div class="annotations-manager__header_filters">
        <div class="annotations-manager__header_filters_show checkbox-container">
          Show:
        </div>
        <div class="checkbox-container">
          <input
            id="checkbox-system"
            v-model="modelValue"
            class="checkbox"
            type="checkbox"
            value="system"
          >
          <label
            for="checkbox-system"
            class="checkbox__label"
          >
            System
          </label>
        </div>
        <div class="checkbox-container">
          <input
            id="checkbox-project"
            v-model="modelValue"
            class="checkbox"
            type="checkbox"
            value="client"
          >
          <label
            for="checkbox-project"
            class="checkbox__label"
          >
            Project
          </label>
        </div>
        <div
          v-if="!disableURL"
          class="checkbox-container"
        >
          <input
            id="checkbox-url"
            v-model="modelValue"
            class="checkbox"
            type="checkbox"
            value="url"
          >
          <label
            for="checkbox-url"
            class="checkbox__label"
          >
            URL
          </label>
        </div>
      </div>
      <button
        v-if="isNotClientCollaborator"
        class="annotations-manager__header_add-new"
        @click.prevent="addNew"
      >
        <base-material-design-icon
          class="annotations-manager__header_add-new_plus"
          icon="plus"
        />
        add new annotation
      </button>
    </div>
    <div class="annotations-manager__main-content">
      <div
        v-if="isAddNew && isNotClientCollaborator"
        class="annotations-manager__main-content_row"
      >
        <div class="annotations-manager__main-content_row_column annotations-manager__main-content_row_date">
          <base-date-picker-button
            v-model="addNewModel.date"
            class="annotations-manager__main-content_row_date_picker"
            big-date-picker
            :min-date="minDate"
            border-less
            without-arrow
            :disabled="addNewModel.disableButtons"
            :title-style="{
              'font-size': '14px',
              'font-weight': 500,
              'text-align': 'center',
              'min-width': 'auto',
              'margin-right': 0,
              'color': addNewModel.errorFields.includes('date') ? '#e11c21' : '#011627'
            }"
            title="Select Date"
          />
        </div>
        <div
          class="annotations-manager__main-content_row_column annotations-manager__main-content_row_note"
          :class="{'annotations-manager__main-content_row_note_error': addNewModel.errorFields.includes('note')}"
        >
          <input
            v-model="addNewModel.note"
            type="text"
            :disabled="addNewModel.disableButtons"
            placeholder="Add annotation here…"
          >
          <template v-if="!disableURL">
            <base-radio
              v-model="addNewModel.type"
              :disabled="addNewModel.disableButtons"
              style="margin-left: 30px;"
              value="url"
              label="URL"
              class="annotations-manager__main-content_row_note__radio-button"
              cross-color="#8F90A6"
            />
            <base-radio
              v-model="addNewModel.type"
              :disabled="addNewModel.disableButtons"
              style="margin-left: 20px;"
              value="client"
              label="Project"
              class="annotations-manager__main-content_row_note__radio-button"
              cross-color="#8F90A6"
            />
          </template>
          <button
            class="annotations-manager__main-content_row_note__save-button"
            :disabled="addNewModel.disableButtons"
            @click.prevent="createUpdateAnnotations(addNewModel)"
          >
            Save
          </button>
        </div>
        <div class="annotations-manager__main-content_row_column annotations-manager__main-content_row_configurator">
          <button
            :disabled="addNewModel.disableButtons"
            class="annotations-manager__main-content_row_configurator__cancel-button"
            @click.prevent="addNew"
          >
            cancel
          </button>
        </div>
      </div>
      <div
        v-for="annotation in annotations"
        :key="annotation.id"
        class="annotations-manager__main-content_row"
      >
        <div class="annotations-manager__main-content_row_column annotations-manager__main-content_row_date">
          <base-date-picker-button
            v-model="annotation.date"
            class="annotations-manager__main-content_row_date_picker"
            big-date-picker
            :min-date="minDate"
            border-less
            without-arrow
            :disabled="!annotation.isEdit || annotation.disableButtons"
            :title-style="{
              'font-size': '14px',
              'font-weight': 500,
              'text-align': 'center',
              'min-width': 'auto',
              'margin-right': 0,
              'color': annotation.errorFields.includes('date') ? '#e11c21' : '#011627'
            }"
            title="Select Date"
          />
        </div>
        <div
          class="annotations-manager__main-content_row_column annotations-manager__main-content_row_note"
          :class="{'annotations-manager__main-content_row_note_error': annotation.errorFields.includes('note')}"
        >
          <div
            v-if="!annotation.isEdit"
            class="annotations-manager__main-content_row_note_text"
          >
            {{ annotation.note }}
          </div>
          <input
            v-else
            v-model="annotation.note"
            type="text"
            :disabled="annotation.disableButtons"
            placeholder="Add annotation here…"
          >
          <template v-if="!annotation.isEdit">
            <div class="annotations-manager__main-content_row_note_type">
              {{ annotation.type === 'client' ? 'Project' : annotation.type === 'url' ? 'URL' : 'System' }}
            </div>
            <base-material-design-icon
              :class="[
                'annotations-manager__main-content_row_note_icon',
                `annotations-manager__main-content_row_note_icon_${annotation.type}`
              ]"
              icon="comment"
            />
          </template>
          <template v-else-if="!disableURL">
            <base-radio
              v-model="annotation.type"
              :disabled="annotation.disableButtons"
              style="margin-left: 30px;"
              value="url"
              label="URL"
              class="annotations-manager__main-content_row_note__radio-button"
              cross-color="#8F90A6"
            />
            <base-radio
              v-model="annotation.type"
              :disabled="annotation.disableButtons"
              style="margin-left: 20px; margin-right: 30px"
              value="client"
              label="Project"
              class="annotations-manager__main-content_row_note__radio-button"
              cross-color="#8F90A6"
            />
          </template>
          <button
            v-if="annotation.isEdit"
            :disabled="annotation.disableButtons"
            class="annotations-manager__main-content_row_note__save-button"
            @click.prevent="createUpdateAnnotations(annotation)"
          >
            Save
          </button>
        </div>
        <!-- <div
          v-if="!annotation.isEdit"
          class="annotations-manager__main-content_row_column annotations-manager__main-content_row_email"
          :class="[`annotations-manager__main-content_row_email_${isNotClientCollaborator ? annotation.type : 'system'}`]"
        >
          {{ annotation.email || '' }}
        </div> -->
        <div
          v-if="annotation.type !== 'system' && isNotClientCollaborator"
          class="annotations-manager__main-content_row_column annotations-manager__main-content_row_configurator"
        >
          <template v-if="!annotation.isEdit">
            <base-material-design-icon
              class="annotations-manager__main-content_row_configurator_edit"
              icon="edit"
              @click="() => { annotation.isEdit = true }"
            />
            <base-material-design-icon
              class="annotations-manager__main-content_row_configurator_trash"
              icon="trash"
              @click="showConfirmModal(annotation.id)"
            />
          </template>
          <template v-else>
            <button
              :disabled="annotation.disableButtons"
              class="annotations-manager__main-content_row_configurator__cancel-button"
              @click.prevent="undoEdit(annotation)"
            >
              cancel
            </button>
          </template>
        </div>
      </div>
    </div>
    <div class="annotations-manager__footer">
      <div
        class="annotations-manager__footer_button"
        @click="close"
      >
        <div class="annotations-manager__footer_close-arrow annotations-manager__footer_close-arrow_left-arrow" />
        <div class="annotations-manager__footer_close-arrow annotations-manager__footer_close-arrow_right-arrow" />
      </div>
    </div>
    <modal
      name="confirm-modal"
      v-bind="modalProps"
    >
      <base-confirm-modal
        title="Are you sure you want to delete this?"
        subtitle="This Annotation will be removed permanently!"
        @confirm="confirmModal"
      />
    </modal>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import moment from 'moment'
import _ from 'lodash'
import ToasterService from '@/services/toasterService'
import baseModalProps from '@/common/BaseModalProps'

const EMPTY_ADD_NEW_MODAL = {
  id: '-1',
  note: '',
  date: '',
  type: 'url',
  disableButtons: false,
  errorFields: []
}
export default {
  name: 'BaseAnnotationsManager',
  model: {
    prop: 'modelValue',
    event: 'change'
  },
  props: {
    modelValue: {
      // default: null
      default: []
    },
    annotations: {
      type: Array,
      default: () => ([])
    },
    disableURL: {
      type: Boolean,
      default: false
    },
    minDate: {
      default: null
    },
    urlId: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      removeId: '',
      isAddNew: false,
      emptyNewModal: { ...EMPTY_ADD_NEW_MODAL },
      addNewModel: {}
    }
  },
  watch: {
    modelValue (v) {
      this.$emit('change', this.modelValue)
    }
  },
  created () {
    if (this.disableURL) {
      this.emptyNewModal.type = 'client'
    }
    this.addNewModel = { ...this.emptyNewModal }
  },
  computed: {
    ...mapState(['currentUser']),
    modalProps () {
      return { ...baseModalProps, height: 'auto', width: '510px' }
    },
    isNotClientCollaborator () {
      return !this.currentUser.isClientCollaborator()
    }
  },
  methods: {
    ...mapActions(['createUpdateAnnotation', 'removeAnnotation']),
    selectType (v) {
      // this.modelValue = v === this.modelValue ? null : v
      this.modelValue = v === this.modelValue ? null : v
      this.$emit('change', this.modelValue)
    },
    close () {
      this.$emit('close')
    },
    addNew () {
      this.isAddNew = !this.isAddNew
      this.addNewModel = { ...this.emptyNewModal }
    },
    showConfirmModal (id) {
      this.removeId = id
      this.$modal.show('confirm-modal')
    },
    async confirmModal (status) {
      this.$modal.hide('confirm-modal')
      if (status) {
        try {
          await this.removeAnnotation(this.removeId)
          this.$emit('updateData')
        } catch (e) {}
      }
    },
    async createUpdateAnnotations (annotation) {
      annotation.disableButtons = true
      const method = annotation.id === '-1' ? 'post' : 'patch'
      const data = {
        ...annotation,
        date: moment(annotation.date).format('YYYY-MM-DD'),
        method,
        fk_user_id: this.currentUser._id,
        fk_pivot_id: annotation.type === 'client' ? this.clientId : this.urlId
      }
      try {
        const response = await this.createUpdateAnnotation(data)
        if (response.is_successful) {
          if (method === 'post') {
            this.addNew()
            ToasterService.showToast(ToasterService.SUCCESS_TYPE, 'Annotation created successfully')
            this.$emit('updateData')
          } else {
            annotation.isEdit = false
            annotation.prevNote = annotation.note
            annotation.prevDate = annotation.date
            annotation.prevType = annotation.type
            annotation.disableButtons = false
            annotation.errorFields = []
            ToasterService.showToast(ToasterService.SUCCESS_TYPE, 'Annotation updated successfully')
            this.$emit('sortAnnotations')
          }
        } else {
          annotation.errorFields = response.error_fields
        }
      } catch (e) {
        if (e.length) {
          e.forEach(i => { ToasterService.showToast(ToasterService.ERROR_TYPE, i) })
        } else {
          ToasterService.showToast(ToasterService.ERROR_TYPE, '500 INTERNAL SERVER ERROR')
        }
      }
      annotation.disableButtons = false
    },
    undoEdit (annotation) {
      annotation.note = annotation.prevNote
      annotation.date = annotation.prevDate
      annotation.type = annotation.prevType
      annotation.errorFields = []
      annotation.disableButtons = false
      annotation.isEdit = false
    }
  }
}
</script>

<style lang="scss" scoped>
  .annotations-manager {
    width: 100%;

    .v--modal-overlay {
      background-color: transparent !important;
    }

    &__header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 40px;
      min-height: 40px;

      &_filters {
        display: flex;
        align-items: center;
        width: 25%;
      }

      &_add-new {
        width: 175px;
        padding-left: 40px;
        padding-right: 20px;
        height: 40px;
        display: block;
        font-size: 10px;
        background-color: transparent;
        font-weight: 900;
        text-transform: uppercase;
        border: none;
        outline: none;
        cursor: pointer;
        color: $rfx-dark-march;
        position: relative;

        &_plus {
          position: absolute;
          left: 18px;
          top: 12px;
          font-size: 17px;
        }

      }
    }

    &__main-content {
      display: flex;
      flex-direction: column;
      border-top: 2px solid #e7e9eb;

      &_row {
        display: flex;
        border-bottom: 2px solid #e7e9eb;

        &_column {
          overflow: hidden;
          height: 55px;
          display: flex;
          align-items: center;
          border-left: 2px solid #e7e9eb;

          &:first-child {
            border-left: none;
          }
        }

        &_date {
          flex: 0 0 140px;
          overflow: visible;

          &_picker {
            margin-left: 8%;
          }
        }

        &_note {
          display: flex;
          justify-content: space-between;
          height: auto;
          align-items: flex-start;
          flex: 1;

          &_text {
            padding: 16px 0 15px 16px;
            width: -webkit-fill-available;
            height: -webkit-fill-available;
            word-break: break-all;
          }

          &_type {
            margin-left: 10px;
            margin-top: 16px;
          }

          &_icon {
            width: 0px;
            margin-left: 13px;
            margin-right: 30px;
            margin-top: 18px;
            align-self: normal;

            &_system {
              color: $rfx-light-red;
            }

            &_client {
              color: $rfx-orange;
            }

            &_url {
              color: $rfx-cyan;
            }
          }

          &__save-button {
            align-self: center;
            border-radius: 4px;
            text-align: center;
            color: white;
            margin-right: 16px;
            text-transform: uppercase;
            background-color: $rfx-cyan;
            outline: none;
            border: none;
            width: 64px;
            height: 32px;
            font-size: 10px;
            font-weight: 900;
            margin-left: 30px;

            &:disabled {
              opacity: .4;
              cursor: default;
            }
          }

          &_error {
            input {
              color: $rfx-red !important;

              &::placeholder {
                color: $rfx-red !important;
              }
            }
          }

          input {
            border: none;
            padding: 16px 0 15px 16px;
            width: -webkit-fill-available;
            height: 22px;

            &:focus {
              border-bottom: 2px solid $rfx-cyan;
              background-color: rgba(40, 74, 255, 0.1);
              outline: none;
            }

            &:disabled {
              background-color: transparent;
              color: $rfx-dark-march;
            }
          }

          &__radio-button {
            align-self: center;
            cursor: pointer;

            &::v-deep .radio__label {
              font-size: 18px;
              font-weight: 500;
            }

            &:disabled {
              opacity: .4;
              cursor: default;
            }
          }
        }

        &_email {
          height: auto;
          align-items: flex-start;
          flex: 0 0 230px;
          padding: 16px 16px 0;
          color: $rfx-dark-march;
          font-size: 14px;
          font-weight: 500;

          &_system {
            flex-basis: 302px;
          }
        }

        &_configurator {
          height: auto;
          align-items: flex-start;
          flex: 0 0 70px;

          &__cancel-button {
            align-self: center;
            text-align: center;
            color: $rfx-dark-march;
            margin: 0 auto;
            text-transform: uppercase;
            background-color: transparent;
            outline: none;
            border: none;
            width: 64px;
            height: 32px;
            font-size: 10px;
            font-weight: 900;

            &:disabled {
              opacity: .4;
              cursor: default;
            }
          }

          &_edit {
            cursor: pointer;
            margin: 15px auto 0;
            font-size: 20px;
            color: $rfx-cyan;
            align-self: flex-start;
          }

          &_trash {
            cursor: pointer;
            margin: 15px auto 0;
            font-size: 20px;
            color: $rfx-red;
            align-self: flex-start;
          }
        }
      }
    }

    &__footer {
      height: 40px;
      display: flex;
      justify-content: center;
      align-items: flex-end;

      &_button {
        display: flex;
      }

      &_close-arrow {
        height: 0;
        width: 0;
        display: flex;
        cursor: pointer;
        border-top: 15px solid $rfx-dark-march;
        border-left: 3px solid $rfx-dark-march;

        &_left-arrow {
          transform: rotate(45deg);
          margin-right: 3px;
        }
        &_right-arrow {
          margin-left: 3px;
          transform: rotate(-45deg);
        }
      }
    }
  }

  .checkbox-container {
    display: flex;
    align-items: center;
    margin-left: 5px;
    cursor: pointer;
  }
  .checkbox {
      cursor: pointer;

    &__label {
      cursor: pointer;
      @include ellipsis;
    }

  }
</style>
